var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallUpWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.061 9.525L14.475 5.939C13.8081 5.30263 12.9218 4.94757 12 4.94757C11.0782 4.94757 10.1919 5.30263 9.525 5.939L5.939 9.525C5.65774 9.8064 5.49978 10.188 5.49988 10.5859C5.49997 10.9837 5.65811 11.3652 5.9395 11.6465C6.2209 11.9278 6.6025 12.0857 7.00036 12.0856C7.39822 12.0855 7.77974 11.9274 8.061 11.646L10.5 9.207V19C10.5 19.3978 10.658 19.7794 10.9393 20.0607C11.2206 20.342 11.6022 20.5 12 20.5C12.3978 20.5 12.7794 20.342 13.0607 20.0607C13.342 19.7794 13.5 19.3978 13.5 19V9.207L15.939 11.646C16.0783 11.7853 16.2436 11.8959 16.4256 11.9713C16.6076 12.0467 16.8027 12.0856 16.9997 12.0856C17.1967 12.0857 17.3917 12.0469 17.5738 11.9716C17.7558 11.8962 17.9212 11.7858 18.0605 11.6465C18.1998 11.5072 18.3104 11.3419 18.3858 11.1599C18.4612 10.9779 18.5001 10.7829 18.5001 10.5859C18.5002 10.3889 18.4614 10.1938 18.3861 10.0118C18.3107 9.82973 18.2003 9.66433 18.061 9.525Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallUpWhite);
export default __webpack_public_path__ + "static/media/arrowSmallUpWhite.f894f9678a6804afbb90be0bc8157b32.svg";
export { ForwardRef as ReactComponent };